import "./Contact.css";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { BiPhoneCall } from "react-icons/bi";
import { FiMail } from "react-icons/fi";
import { Box, SimpleGrid, useColorMode } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Typewriter } from 'react-simple-typewriter';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Contact = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const form = useRef();

  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    user_number: "",
    message: ""
  });

  const [formErrors, setFormErrors] = useState({
    emailError: "",
    numberError: ""
  });

  const [isFormValid, setIsFormValid] = useState(false);

  // Handle form changes and validate inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let emailError = "";
    let numberError = "";

    // Update form data
    setFormData({
      ...formData,
      [name]: value
    });

    // Validate email
    if (name === "user_email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      emailError = emailRegex.test(value) ? "" : "Please enter a valid email";
    }

    // Validate number (should be exactly 10 digits)
    if (name === "user_number") {
      numberError = value.length === 10 ? "" : "Contact number must be 10 digits";
    }

    setFormErrors({ emailError, numberError });

    // Check if the form is valid (no errors and all fields filled)
    if (
      formData.user_name &&
      formData.user_email &&
      formData.user_number &&
      formData.message &&
      !emailError &&
      !numberError
    ) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_a1vwnwi",
        "template_i0dplxh",
        form.current,
        "FJAPqqzCeBlJplTSf"
      )
      .then(
        (result) => {
          toast.success('Message sent successfully!', { autoClose: 3000 });
          console.log(result.text);
          // Clear form after successful submission
          setFormData({
            user_name: "",
            user_email: "",
            user_number: "",
            message: ""
          });
          setIsFormValid(false); // Disable the button again
        },
        (error) => {
          toast.error('Failed to send message!', { autoClose: 3000 });
          console.log(error.text);
        }
      );
  };

  return (
    <div
      style={{
        backgroundColor: colorMode === "light" ? "#edf2f8" : "#1a202c",
      }}
      className="contact_container"
      id="contact"
    >
      <ToastContainer />
      <div className="contact_content">
        <div className="contact_heading">
          <h2>
            Con<span>tact</span><span></span>
          </h2>
        </div>

        <div className="bothbox">
          <SimpleGrid columns={[1, 1, 1, 2]} spacing="50px">
            <Box>
              <div className="contact_image" style={{ padding: "80px 0 0 0" }}>
                <img
                  src="https://mohit-portfolio.vercel.app/assets/contact.f495edec.svg"
                  alt="Contact"
                />
              </div>
            </Box>
            <Box>
              <div className="input_box">
                <div className="contact_icon">
                  <SimpleGrid columns={[1, 2, 2, 2]} spacing="20px">
                    <Box className="icon_box">
                      <a
                        href="https://www.linkedin.com/in/prakash-singh-47018519a"
                        rel="noopener norefferer"
                        target="_blank"
                      >
                        <div className="icon" id="icon1">
                          <FaLinkedin />
                          <h3>LinkedIn</h3>
                        </div>
                      </a>
                    </Box>
                    <Box className="icon_box">
                      <a
                        href="https://github.com/singhprakash14"
                        rel="noopener norefferer"
                        target="_blank"
                      >
                        <div className="icon" id="icon2">
                          <FaGithub />
                          <h3>GitHub</h3>
                        </div>
                      </a>
                    </Box>
                    <Box className="icon_box">
                      <a
                        href="mailto:prakashsingh12320@gmail.com"
                        rel="noopener norefferer"
                        target="_blank"
                      >
                        <div className="icon" id="icon3">
                          <FiMail />
                          <h3>Gmail</h3>
                        </div>
                      </a>
                    </Box>
                  </SimpleGrid>
                </div>

                <div className="contact_information">
                  <form ref={form} onSubmit={sendEmail}>
                    <div>
                      <input
                        required={true}
                        name="user_name"
                        className="input_tag"
                        type="text"
                        placeholder="Full Name"
                        value={formData.user_name}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <input
                        required={true}
                        name="user_email"
                        className="input_tag"
                        type="text"
                        placeholder="Email"
                        value={formData.user_email}
                        onChange={handleInputChange}
                      />
                      <span className="error_message">{formErrors.emailError}</span>
                    </div>
                    <div>
                      <input
                        required={true}
                        name="user_number"
                        className="input_tag"
                        type="number"
                        placeholder="Number"
                        value={formData.user_number}
                        onChange={handleInputChange}
                      />
                      <span className="error_message">{formErrors.numberError}</span>
                    </div>
                    <div className="input_message">
                      <textarea
                        required={true}
                        name="message"
                        className="input_tag_text_message"
                        type="text"
                        placeholder="Your Message"
                        value={formData.message}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="input_btn"
                        disabled={!isFormValid}
                        style={{
                          backgroundColor: isFormValid ? "#6f11eb" : "lightgrey",
                          cursor: isFormValid ? "pointer" : "not-allowed",
                        }}
                      >
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </Box>
          </SimpleGrid>
        </div>
      </div>
      <br />
      <div className="footer" style={{ textAlign: "center" }}>
        <span style={{ fontSize: '20px', color: 'red', fontWeight: 'bold' }}>
          <Typewriter
            words={['Made with 💗 by Prakash']}
            loop={5000000000}
            cursor
            cursorStyle='|'
            typeSpeed={100}
            deleteSpeed={100}
            delaySpeed={2000}
          />
        </span>
      </div>
    </div>
  );
};
